import React,{useState,useEffect,useRef} from "react";
import './Music.css'
import AlbumExampleImg2 from './../../../../images/albumexampleimg2.png'
import PurpleBackIcon from './../../../../images/purplebackicon.png'
import PinkBackIcon from './../../../../images/pinkbackicon.png'
import BackIcon from './../../../../images/backicon.png'
import Nomusicimg from './../../../../images/nomusicimg.png'
import DraftCover from './../../../../images/draftalbumcover.png'
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select'
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {Route,Routes, Redirect, Navigate} from 'react-router-dom'
import AlbumList from "./AlbumList";
import AlbumDetails from "./AlbumDetails";
import TrackDetails from "./TrackDetails";
import { useJwt, decodeToken } from "react-jwt";
import { logtoWix } from "../../../Helpers/LogToWix";

function Music({nav,shareData,prevPage,hidedashboard}) {
    const [toggledetails,setToggleDetails] = useState(false)
    const [noMusic,setNoMusic] = useState(true)
    const [loading,setLoading] = useState(true)
    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
      })
      const navigate = useNavigate();

      const {t, i18n } = useTranslation();
      const cookies = new Cookies(null ,{ path: '/' });
       const hasLogged = useRef(false);

      const [dummyalbums,setDummyAlbums] = useState([
        {name:"Vivid Reflection",image:"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj",status:"PENDING",artist:"Peggy Gou",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",format:"ALBUM",
         tracks:[ 
         {trackno:"1",trackname:"Echoes of Yesterday",tracklength:"3:20",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]},
         {trackno:"2",trackname:"Ripples",tracklength:"2:45",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]}
         ]
        },
        {name:"Don't Waste A Minute",image:AlbumExampleImg2,status:"RELEASED",artist:"Peggy Gou",label:"J.A.C",genre:"R&B",releasedate:"Nov 31,2023",format:"ALBUM",
         tracks:[
         {trackno:"1",trackname:"City of Palm",tracklength:"3:20",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]},
         {trackno:"2",trackname:"Minute mark",tracklength:"2:45",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]},
         {trackno:"3",trackname:"Chronos",tracklength:"4:11",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]},
         {trackno:"4",trackname:"Now or Never",tracklength:"3:40",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]},
         {trackno:"5",trackname:"Second's Sway",tracklength:"5:01",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]},
         {trackno:"6",trackname:"Twist",tracklength:"3:22",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist:"Peggy Gou",Artistpercent:"60%"},{Artist:"Artist Name",Artistpercent:"40%"}]}
        ]}
        ])
      

      useEffect(() => {
        function handleResize() {
          setDimensions({
            height: window.innerHeight,
            width: window.innerWidth
          })
        
    }

        window.addEventListener('resize', handleResize)
    
        return _ => { 
          window.removeEventListener('resize', handleResize)
        }
      })

      function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
    useEffect(()=>{
        topFunction()
        hidedashboard(true)
        nav("Music")
        if(cookies.get("artistname").length!==0){
            setNoMusic(false)
        }

         if (!hasLogged.current) {
                    if (cookies.get('token') !== undefined) {
                        if (decodeToken(cookies.get('token')) !== null) {
                            logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Artist Dashboard My Music Page", { "desc": "User opened the artist dashboard my music page" })
                            hasLogged.current = true;
                        } else {
                            logtoWix("anonymous user", "pageview", "Artist Dashboard My Music Page", { "desc": "User opened the artist dashboard my music page" })
                            hasLogged.current = true;
                        }
                    } else {
                        logtoWix("anonymous user", "pageview", "Artist Dashboard My Music Page", { "desc": "User opened the artist dashboard my music page" })
                        hasLogged.current = true;
                    }
          }

    },[])


    return (
        <div style={{minHeight:'100vh',height:'auto',paddingBottom:'10em'}}>
            {
                noMusic &&
                <div style={{height:document.body.scrollHeight,display:'flex',flexDirection:'column',alignItems:"center"}}>
                
                <img src={Nomusicimg} style={{height:'16.5em',width:'15em',marginTop:'9.81em',marginBottom:'1.5em'}}/>
                <div className="NoReleaseH1">No Release Yet</div>   
                <div className="NoReleaseH2">Your music will be listed here once you release it. Ready to share your sound with the world? Start your first release now!</div>   
                <div className="ReleaseMusicRedBtn" onClick={()=>navigate("/Dashboard/releasemusic")}>Release Music</div>
                </div>
               
            }

            {
                !noMusic &&
                <Routes>
                     <Route exact path="/" element={<AlbumList shareData={shareData} prevPage={prevPage} dummyalbums={dummyalbums}/>}/>
                     <Route exact path="/albumdetails" element={<AlbumDetails hidedashboard={hidedashboard} nav={nav} />}/>
                     <Route exact path="/trackdetails" element={<TrackDetails hidedashboard={hidedashboard} nav={nav}/>}/>
                </Routes>
            }
           

        </div>
        
    );
}

export default Music;

// import React,{useState,useEffect} from "react";
// import './Music.css'
// import AlbumExampleImg from './../../../../images/albumexampleimg.png'
// import AlbumExampleImg2 from './../../../../images/albumexampleimg2.png'
// import PurpleBackIcon from './../../../../images/purplebackicon.png'
// import PinkBackIcon from './../../../../images/pinkbackicon.png'
// import BackIcon from './../../../../images/backicon.png'
// import playsongicon from './../../../../images/playsongicon.png'
// import Nomusicimg from './../../../../images/nomusicimg.png'
// import DraftCover from './../../../../images/draftalbumcover.png'
// import CircularProgress from '@mui/material/CircularProgress';
// import Select from 'react-select'
// import { Trans, useTranslation} from 'react-i18next'
// import i18next from "i18next"
// import Cookies from 'universal-cookie';
// import axios from "axios";
// import {useNavigate} from "react-router-dom";
// import {Route,Routes, Redirect, Navigate} from 'react-router-dom'

// function Music({nav,shareData,prevPage,hidedashboard}) {
//     const [toggledetails,setToggleDetails] = useState(false)
//     const [viewoption,setViewOption] = useState({ value: 'All', label: 'All'})
//     const [artistName,setArtistName] = useState("Peggy Gou")
//     const [labelName,setLabelName] = useState("J.A.C")
//     const [genre,setGenre] = useState("R&B")
//     const [noMusic,setNoMusic] = useState(true)
//     const [releaseDate,setReleaseDate] = useState("Nov 21, 2023")
//     const [format,setFormat] = useState()
//     const [dummyalbums,setDummyAlbums] = useState([
//                                         {name:"Vivid Reflection",status:"PENDING",artist:"Peggy Gou",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",format:"ALBUM",
//                                          tracks:[ 
//                                          {trackno:"1",trackname:"Echoes of Yesterday",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]},
//                                          {trackno:"2",trackname:"Ripples",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]}
//                                          ]
//                                         },
//                                         {name:"Don't Waste A Minute",status:"RELEASED",artist:"Peggy Gou",label:"J.A.C",genre:"R&B",releasedate:"Nov 31,2023",format:"ALBUM",
//                                          tracks:[
//                                          {trackno:"1",trackname:"City of Palm",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]},
//                                          {trackno:"2",trackname:"Minute mark",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]},
//                                          {trackno:"3",trackname:"Chronos",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]},
//                                          {trackno:"4",trackname:"Now or Never",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]},
//                                          {trackno:"5",trackname:"Second's Sway",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]},
//                                          {trackno:"6",trackname:"Twist",label:"J.A.C",genre:"R&B",releasedate:"Nov 21,2023",songwriters:"Peggy Gou",producers:"Jonny Greenwood",featuredartists:"Thome Yorke",explicitcontent:"No",instrumental:"No",radioedit:"No",price:"0.99",royaltysplit:[{Artist1:"Peggy Gou",Artist1percent:"60%"},{Artist2:"Artist Name",Artist2percent:"40%"}]}
//                                         ]}
//                                         ])
//     const [showtrackdetails,setShowTrackDetails]= useState(false)
//     const [albumDraft,setAlbumDraft] = useState([])
//     const [track,setTrack] = useState({ "trackno":"1",
//                                         "trackname":"Echoes of Yesterday",
//                                         "label":"J.A.C",
//                                         "genre":"R&B",
//                                         "releasedate":"Nov 21,2023",
//                                         "songwriters":"Peggy Gou",
//                                         "producers":"Jonny Greenwood",
//                                         "featuredartists":"Thome Yorke",
//                                         "explicitcontent":"No",
//                                         "instrumental":"No",
//                                         "radioedit":"No",
//                                         "price":"0.99",
//                                         "royaltysplit":[{"Peggy Gou":"60%"},{"Artist Name":"40%"}]})
//     const [albumname,setAlbumName] = useState()
//     const [albumAnalyticsOption,setAlbumAnalyticsOption] = useState(1)
//     const [loading,setLoading] = useState(true)
//     const [dimensions, setDimensions] = useState({ 
//         height: window.innerHeight,
//         width: window.innerWidth
//       })
//       const formatOptions = [{ value: 'All release', label:'All release' },
//       { value: 'Single', label: 'Single' },
//       { value: 'Album', label: 'Album' },
//       { value: 'EP', label: 'EP' }] 
//       const navigate = useNavigate();

//       const {t, i18n } = useTranslation();
//       const cookies = new Cookies(null ,{ path: '/' });
    
//       const changeFormatHandler = value => {
//         setFormat(value) 
//     }

//     const TrackDetailsComplexStyles = {
//         control: styles => ({ ...styles,  borderColor: '#636468',
//         backgroundColor:'rgba(0,0,0,16%)',
//         width: '15em',
//         height: '3em',
//         marginRight:'1em',
//         color:'rgba(255, 255, 255, 1)',
//         "&:hover": {
//           backgroundColor: "rgba(254,254,254,20%)"
//         }
//       }),
//       menu:  styles => ({ ...styles, 
//       color:'rgba(255, 255, 255, 1)',
//       borderColor:'#636468',
//       width: '15em',
//       borderTopLeftRadius:'4px',
//       borderTopRightRadius:'4px',
//       marginTop:'0.3em',
//       border:'0.5px rgba(255,255,255,10%) solid'
//      }),
//         option: (styles, { data, isDisabled, isFocused, isSelected }) => {
//           return {
//             ...styles,
//             backgroundColor:'#2A333D' ,
//             color:'rgba(255, 255, 255, 1)',
//             cursor: isDisabled ? 'not-allowed' : 'default',
//             marginTop:'-0.3em',
//             marginBottom:'-0.3em',
//             "&:hover": {
//               backgroundColor: 'rgba(0,0,0,100%)'
//             }
//           };
//         },
//         input: (styles) => ( {...styles , 
//                                 FontFamily:'ClashGrotesk-Variable,sans-serif',
//                                 FontSize:'1rem',
//                                 FontWeight: 'medium',
//                                 LineHeight: '150%',
//                                 LetterSpacing: '0%',
//                                 color:'rgba(255, 255, 255, 1)',
//                                 borderTopLeftRadius:'4px',
//                                 borderTopRightRadius:'4px',}),
//         singleValue : (styles) => ({ ...styles, 
//                                         color:'rgba(255, 255, 255, 1)',
//                                         FontFamily:'ClashGrotesk-Variable,sans-serif',
//                                         FontSize:'1rem',
//                                         FontWeight: 'medium',
//                                         LineHeight: '150%',
//                                         LetterSpacing: '0%'}),
//          hover : styles =>({
//                                           backgroundColor:'rgba(255,255,255,8%)',
//           }),
//           menuList: (base) => ({
//             ...base,
        
//             "::-webkit-scrollbar": {
//               width: "0px",
//               height: "0px",
//             },
//             "::-webkit-scrollbar-track": {
//               background: "#f1f1f1"
//             },
//             "::-webkit-scrollbar-thumb": {
//               background: "#888"
//             },
//             "::-webkit-scrollbar-thumb:hover": {
//               background: "#555"
//             }
//           })
//       };

//       useEffect(() => {
//         function handleResize() {
//           setDimensions({
//             height: window.innerHeight,
//             width: window.innerWidth
//           })
        
//     }

    
//         window.addEventListener('resize', handleResize)
    
//         return _ => { 
//           window.removeEventListener('resize', handleResize)
//         }
//       })

//       function topFunction() {
//         document.body.scrollTop = 0; // For Safari
//         document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
//       }
    
//     useEffect(()=>{
//         topFunction()
//         hidedashboard(true)
//         nav("Music")
//         if(cookies.get("artistname").length!==0){
//             setNoMusic(false)
//           }
//           getProducts()
//     },[])

//     const changeViewHandler = value => {
//         setViewOption(value)
//     }

//     const getProducts = () =>{
//         axios({
//             method:'get',
//             url:"https://n3rve.fly.dev/products",
//             headers:{
//                 Authorization: "Bearer ".concat(cookies.get("token"))
//             }
//         }).then(res=>{
//           console.log(res)
//           setAlbumDraft(res.data)
//         }).catch((e)=>{
//           console.log(e)
//         }).finally(()=>{
//             setLoading(false)
//         })
//     }

//     const viewOptions = [{ value: 'All', label: 'All'}]
//     const jpviewOptions = [{ value: 'All', label: '全て'}]

//     const colourStyles = {
//         control: styles => ({ ...styles,  borderColor: '#636468',
//         backgroundColor:'#182833',
//         width: '10em',
//         height: '2.5em',
//         borderRadius:'8px',
//         color:'rgba(255, 255, 255, 1)',
//         marginLeft:'0.5em'
//        }),
//         option: (styles, { data, isDisabled, isFocused, isSelected }) => {
//           return {
//             ...styles,
//             backgroundColor:'#18191F' ,
//             color:'rgba(255, 255, 255, 1)',
//             cursor: isDisabled ? 'not-allowed' : 'default',
//             marginTop:'-0.3em',
//             marginBottom:'-0.3em',
//             borderRadius:'3px'
//           };
//         },
//         input: (styles) => ( {...styles , 
//                                 FontFamily:'ClashGrotesk-Variable,sans-serif',
//                                 FontSize:'1rem',
//                                 FontWeight: 'medium',
//                                 LineHeight: '150%',
//                                 LetterSpacing: '0%',
//                                 color:'rgba(255, 255, 255, 1)'}),
//         singleValue : (styles) => ({ ...styles, 
//                                         color:'rgba(255, 255, 255, 1)',
//                                         FontFamily:'ClashGrotesk-Variable,sans-serif',
//                                         FontSize:'1rem',
//                                         FontWeight: 'medium',
//                                         LineHeight: '150%',
//                                         LetterSpacing: '0%'
//                                         }),
//         menuList: (base) => ({ ...base,
//                                         "::-webkit-scrollbar": {
//                                             width: "0px",
//                                             height: "0px",
//                                         },
//                                         "::-webkit-scrollbar-track": {
//                                             background: "#f1f1f1"
//                                         },
//                                         "::-webkit-scrollbar-thumb": {
//                                             background: "#888"
//                                         },
//                                         "::-webkit-scrollbar-thumb:hover": {
//                                             background: "#555"
//                                             }
//                                           })
//       };

//     return (
//         <div style={{height:'100vh',overflowY:'scroll'}}>
//             {
//                 noMusic &&
//                 <div style={{height:document.body.scrollHeight,display:'flex',flexDirection:'column',alignItems:"center"}}>
                
//                 <img src={Nomusicimg} style={{height:'16.5em',width:'15em',marginTop:'9.81em',marginBottom:'1.5em'}}/>
//                 <div className="NoReleaseH1">No Release Yet</div>   
//                 <div className="NoReleaseH2">Your music will be listed here once you release it. Ready to share your sound with the world? Start your first release now!</div>   
//                 <div className="ReleaseMusicRedBtn" onClick={()=>navigate("/Dashboard/releasemusic")}>Release Music</div>
//                 </div>
               
//             }
//             {
//                 !noMusic &&
//             <div className="MusicContainer" style={{height:dimensions.height}}>
            
//             {
//                 !toggledetails && !showtrackdetails &&
//                 <div style={{display:'flex',flexDirection:'column',width:'100%',alignItems:'center'}}>
//                 <div className="MusicHeaderMain">MY MUSIC</div>
//                 <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',width:'93.28%',alignSelf:'center',marginTop:'1.5em',borderBottom:'rgba(255,255,255,25%) 0.5px solid',paddingBottom:'1em'}}> 
//                     <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
//                         {/* <div className="TypeTxt">{t('Type:')}</div>
//                         <div style={{display:'flex',flexDirection:'column'}}>
//                         <div className="Genreheader">{t('Genre')}</div>
//                         {
//                             cookies.get('lang') === 'en' &&
//                             <Select options={viewOptions} value={viewoption} onChange={changeViewHandler} 
//                             components={{
//                                 IndicatorSeparator: () => null
//                             }}
//                             styles={
//                                 colourStyles
//                             }
//                             defaultValue={{ label: "All", value: "All"}}
//                         />
//                         }
//                         {
//                             cookies.get('lang') === 'jp' &&
//                             <Select options={jpviewOptions} value={viewoption} onChange={changeViewHandler} 
//                             components={{
//                                 IndicatorSeparator: () => null
//                             }}
//                             styles={
//                                 colourStyles
//                             }
//                             defaultValue={{ label: "All", value: "All"}}
//                         />
//                         }
                       
//                         </div> */}
//                     </div>
                    
//                     <Select options={formatOptions} value={format}  onChange={changeFormatHandler} 
//                     components={{
//                       IndicatorSeparator: () => null
//                     }}
//                     placeholder="All release"
//                     isSearchable
//                     styles={
//                       TrackDetailsComplexStyles
//                     }
//                     />

//                     <div className="ReleaseMusicBtn" onClick={()=>navigate("/Dashboard/releasemusic")}> 
//                        + {t('Releasemusic')}
//                        <div className="PostLoginBtnOverlay"/>
//                     </div>
//                 </div>

//                 <div className="AlbumsContainer">
//                     <div className="AlbumTxt">{t('Album')}</div>
//                     <div style={{display:'flex',flexDirection:'row', marginLeft:'1em',paddingRight:'2.5em',paddingTop:'1.8em',paddingBottom:'2.5em',flexWrap:'wrap'}}>

//                     <div className="AlbumCard" onClick={()=>{setToggleDetails(!toggledetails); setAlbumName("Don't Waste A Minute")}}>
//                         <img src={AlbumExampleImg2} alt="Album Cover Img" className="AlbumCover"/>
//                         <div className="AlbumTitle">{t('Album')}</div>
//                         <div className="AlbumName">Don't Waste A Minute</div>
//                         <div className="AlbumDate">{t('Releasedate')} : August 31,2023</div>
//                         <div className="AlbumStatus" style={{color:'#60E5C5'}}>{t('Releasedstatus')}</div>
//                     </div>

//                     <div className="AlbumCard" onClick={()=>{setToggleDetails(!toggledetails); setAlbumName("Vivid Reflection")}}>
//                         <img src={AlbumExampleImg} alt="Album Cover Img" className="AlbumCover"/>
//                         <div className="AlbumTitle">{t('Album')}</div>
//                         <div className="AlbumName">Vivid Reflection</div>
//                         <div className="AlbumDate">{t('Releasedate')} : August 31,2023</div>
//                         <div className="AlbumStatus">{t('Pendingstatus')}</div>
//                     </div>
                    
//                     {
//                         loading &&
//                         <CircularProgress style={{position:'fixed',width:'5em',height:'5em',marginLeft:'45%',marginTop:'4em'}} sx={{color:'#FFFFFF'}}/>
//                     }
                    

//                     {
//                         albumDraft.map((item,index)=>{
                            
//                             return (
//                             <div className="AlbumCard" onClick={()=>{prevPage("Music");shareData(item);navigate("/Dashboard/releasemusic")}} >
//                                 <img src={DraftCover} alt="Album Cover Img" className="AlbumCover"/>
//                                 <div className="AlbumTitle">{t('Album')}</div>
//                                 {
//                                     item.name===undefined &&
//                                     <div className="AlbumName">Untitled</div>
//                                 }
//                                 {
//                                     item.name!==undefined &&
//                                     <div className="AlbumName">{item.name}</div>
//                                 }
                                
//                                 <div className="AlbumStatus">DRAFT</div>
//                             </div>
//                             )
//                         })
//                     }

//                     </div>
//                 </div>


//                 </div>  
//             }

//             {
//                 (toggledetails && albumname==="Vivid Reflection") &&
//                 <div style={{display:'flex',flexDirection:'column',width:"100%"}}>
//                     <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end',justifyContent:'flex-start',width:'95%',alignSelf:'center'}}>
//                                             <img src={BackIcon} alt="back icon" style={{width:'1.7em',height:'1.7em',cursor:'pointer'}} onClick={()=>setToggleDetails(!toggledetails)}/>
//                                             <div className="MusicHeader" style={{color:'#FFFFFF',cursor:'pointer',textDecoration:'underline'}} onClick={()=>{setToggleDetails(!toggledetails);setShowTrackDetails(false)}}>All</div>
//                                             <div className="MusicHeader" style={{paddingLeft:'0.7em'}}>/&nbsp; &nbsp;{albumname}</div>
//                     </div>

//                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'90%',borderRadius:'8px',marginLeft:'2.5em',marginTop:'2.5em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                      
//                         <img src={AlbumExampleImg} alt="Album Cover Img" className="AlbumInfoCover"/>

//                         <div style={{display:'flex',flexDirection:'column',marginTop:'1.5em'}}>
//                             <div className="AlbumInfoHeader">{t('Album')}</div>
//                             <div className="AlbumInfoName">{albumname}</div>
//                             <div className="AlbumInfoStatus">{t('Pendingstatus')}</div>

//                             <div style={{display:'flex',flexDirection:'row',marginLeft:'5em'}}>
//                                 <div style={{display:'flex',flexDirection:'column'}}>
//                                     <div className="MetadataLabel">{t('Artisttag')}</div>
//                                     <div className="MetadataLabel">{t('Labeltag')}</div>
//                                     <div className="MetadataLabel">{t('Genretag')}</div>
//                                     <div className="MetadataLabel">{t('Releasedatetag')}</div>
//                                     <div className="MetadataLabel">{t('Formattag')}</div>
//                                 </div>

//                                 <div style={{display:'flex',flexDirection:'column'}}>
//                                     <div className="MetadataInfo">Peggy Gou</div>
//                                     <div className="MetadataInfo">J.A.C</div>
//                                     <div className="MetadataInfo">R&B</div>
//                                     <div className="MetadataInfo">Nov 21,2023</div>
//                                     <div className="MetadataInfo">{t('Album')}</div>
//                                 </div>
//                             </div>
                         
//                         </div>
//                     </div>

                   
//                 <div style={{display:'flex',flexDirection:'column',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
//                     <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em',width:'90.38%',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em'}}>
//                         <div className="TrackTableHeader" style={{width:'8%'}}>  </div>
//                         <div className="TrackTableHeader" style={{width:'25%'}}>{t('Name')}</div>
//                         <div className="TrackTableHeader" style={{width:'20%'}}>{t('Artist')}</div>
//                         <div className="TrackTableHeader" style={{width:'30%'}}>{t('Duration')}</div>
                 
//                     </div>

//                     <div style={{backgroundColor:'#595959',height:'1px',width:'90.38%',marginTop:'0.8em',marginBottom:'0.1em',marginLeft:'2.5em'}}/>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>1.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>Echoes of Yesterday</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>3:20</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>2.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>Ripples</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>2:45</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>
//                 </div>

//                 <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
//                     <div style={{display:'flex',flexDirection:'row',justifyContent:'center',marginTop:'3em',width:'100%',alignSelf:'center'}}>
//                         {
//                             albumAnalyticsOption===1 &&
//                             <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
//                                {t('1wk')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption!==1 &&
//                             <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
//                                {t('1wk')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption===2 &&
//                             <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
//                                {t('1mo')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption!==2 &&
//                             <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
//                                {t('1mo')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption===3 &&
//                             <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
//                                {t('All')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption!==3 &&
//                             <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
//                                 {t('All')} 
//                             </div>
//                         }                       

//                     </div>

//                     <div className="StreamsTxt">
//                            {t('Streams')} 
//                     </div>
                    
//                     {
//                        albumAnalyticsOption===1 && 
//                        <div className="StreamsNo">
//                        85.5k
//                         </div>
//                     }

//                     {
//                        albumAnalyticsOption===2 && 
//                        <div className="StreamsNo">
//                        402k
//                         </div>
//                     }

//                     {
//                        albumAnalyticsOption===3 && 
//                        <div className="StreamsNo">
//                        1.93M
//                         </div>
//                     }   
                 
//                 </div>
//             </div>
//             }

//            {
//                 (toggledetails && albumname==="Don't Waste A Minute") &&
//                 <div style={{display:'flex',flexDirection:'column',width:"100%"}}>
//                         <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end',justifyContent:'flex-start',width:'95%',alignSelf:'center'}}>
//                                             <img src={BackIcon} alt="back icon" style={{width:'1.7em',height:'1.7em',cursor:'pointer'}} onClick={()=>setToggleDetails(!toggledetails)}/>
//                                             <div className="MusicHeader" style={{color:'#FFFFFF',cursor:'pointer',textDecoration:'underline'}} onClick={()=>{setToggleDetails(!toggledetails);setShowTrackDetails(false)}}>All</div>
//                                             <div className="MusicHeader" style={{paddingLeft:'0.7em'}}>/&nbsp; &nbsp;{albumname}</div>
//                         </div>

//                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'90%',borderRadius:'8px',marginLeft:'2.5em',marginTop:'2.5em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                      
//                         <img src={AlbumExampleImg2} alt="Album Cover Img" className="AlbumInfoCover"/>

//                         <div style={{display:'flex',flexDirection:'column',marginTop:'1.5em'}}>
//                             <div className="AlbumInfoHeader">{t('Album')}</div>
//                             <div className="AlbumInfoName">{albumname}</div>
//                             <div className="AlbumInfoStatus" style={{color:'#60E5C5'}}>{t('Releasedstatus')}</div>

//                             <div style={{display:'flex',flexDirection:'row',marginLeft:'5em'}}>
//                                 <div style={{display:'flex',flexDirection:'column'}}>
//                                     <div className="MetadataLabel">{t('Artisttag')}</div>
//                                     <div className="MetadataLabel">{t('Labeltag')}</div>
//                                     <div className="MetadataLabel">{t('Genretag')}</div>
//                                     <div className="MetadataLabel">{t('Releasedatetag')}</div>
//                                     <div className="MetadataLabel">{t('Formattag')}</div>
//                                 </div>

//                                 <div style={{display:'flex',flexDirection:'column'}}>
//                                     <div className="MetadataInfo">Peggy Gou</div>
//                                     <div className="MetadataInfo">J.A.C</div>
//                                     <div className="MetadataInfo">R&B</div>
//                                     <div className="MetadataInfo">Aug 31, 2023</div>
//                                     <div className="MetadataInfo">{t('Album')}</div>
//                                 </div>
//                             </div>
                         
//                         </div>
//                     </div>

                   
//                 <div style={{display:'flex',flexDirection:'column',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
//                     <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em',width:'90.38%',alignSelf:'flex-end'}} >
//                         <div className="TrackTableHeader" style={{width:'8%'}}>  </div>
//                         <div className="TrackTableHeader" style={{width:'25%'}}>{t('Name')}</div>
//                         <div className="TrackTableHeader" style={{width:'20%'}}>{t('Artist')}</div>
//                         <div className="TrackTableHeader" style={{width:'30%'}}>{t('Duration')}</div>
                 
//                     </div>

//                     <div style={{backgroundColor:'#595959',height:'1px',width:'90.38%',marginTop:'0.8em',marginBottom:'0.1em',marginLeft:'2.5em'}}/>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>1.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>City of Palm</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>3:20</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>2.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>Minute mark</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>2:45</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>3.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>Chronos</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>4:11</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>4.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>Now or Never</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>3:40</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>5.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>Second's Sway</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>5:01</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>

//                     <div className="SelectedTrack" style={{display:'flex',flexDirection:'row',width:'90.38%',marginLeft:'4.68em',alignSelf:'flex-end',marginRight:'1em',paddingLeft:'1em',paddingBottom:'1em',cursor:'pointer'}} onClick={()=>{setShowTrackDetails(true);setToggleDetails(false)}}>
//                         <div className="TrackTableRow" style={{width:'8%'}}>6.</div>
//                         <div className="TrackTableRow" style={{width:'25%'}}>Twist</div>
//                         <div className="TrackTableRow" style={{width:'20%'}}>Peggy Gou</div>
//                         <div className="TrackTableRow" style={{width:'30%'}}>3:22</div>
//                         {/* <div className="TrackTableRow">$0.99</div> */}
//                         <img src={playsongicon} style={{width:'2.5em',height:'2.5em',marginTop:'1.3em'}}/>
//                     </div>
//                 </div>

//                 <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
//                     <div style={{display:'flex',flexDirection:'row',justifyContent:'center',marginTop:'3em',width:'100%',alignSelf:'center'}}>
//                         {
//                             albumAnalyticsOption===1 &&
//                             <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
//                                  {t('1wk')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption!==1 &&
//                             <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
//                                 {t('1wk')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption===2 &&
//                             <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
//                                 {t('1mo')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption!==2 &&
//                             <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
//                                 {t('1mo')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption===3 &&
//                             <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
//                                  {t('All')} 
//                             </div>
//                         }

//                         {
//                             albumAnalyticsOption!==3 &&
//                             <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
//                                  {t('All')} 
//                             </div>
//                         }                       

//                     </div>

//                     <div className="StreamsTxt">
//                         {t('Streams')} 
//                     </div>
                    
//                     {
//                        albumAnalyticsOption===1 && 
//                        <div className="StreamsNo">
//                        85.5k
//                         </div>
//                     }

//                     {
//                        albumAnalyticsOption===2 && 
//                        <div className="StreamsNo">
//                        402k
//                         </div>
//                     }

//                     {
//                        albumAnalyticsOption===3 && 
//                        <div className="StreamsNo">
//                        1.93M
//                         </div>
//                     }   
                 
//                 </div>
//             </div>
//             }

//             {
//                 !toggledetails && showtrackdetails  &&
//                 <div style={{display:'flex',flexDirection:'column',width:"100%"}}>
//                 <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end',justifyContent:'flex-start',width:'95%',alignSelf:'center'}}>
//                     <img src={BackIcon} alt="back icon" style={{width:'1.7em',height:'1.7em',cursor:'pointer'}} onClick={()=>setToggleDetails(!toggledetails)}/>
//                     <div className="MusicHeader" style={{color:'#FFFFFF',cursor:'pointer',textDecoration:'underline'}} onClick={()=>{setToggleDetails(false);setShowTrackDetails(false)}}>All</div>
//                     <span className="MusicHeader" style={{paddingLeft:'0.4em'}}>/&nbsp; <span style={{color:'#FFFFFF',cursor:'pointer'}} onClick={()=>{setToggleDetails(!toggledetails);setShowTrackDetails(false)}}>{albumname}</span></span>
//                     <span className="MusicHeader" style={{paddingLeft:'0.4em'}}>/&nbsp; {track.trackname}</span>
//                 </div>

//                 <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'90%',borderRadius:'8px',marginLeft:'2.5em',marginTop:'2.5em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                  
//                     <img src={AlbumExampleImg} alt="Album Cover Img" className="AlbumInfoCover"/>

//                     <div style={{display:'flex',flexDirection:'column',marginTop:'1.5em',paddingBottom:'2em'}}>
//                         <div className="AlbumInfoHeader">{t('Track')} {track.trackno}</div>
//                         <div className="AlbumInfoName">{albumname}</div>
//                         <div className="AlbumInfoStatus">{t('Pendingstatus')}</div>

//                         <div style={{display:'flex',flexDirection:'row',marginLeft:'5em'}}>
//                             <div style={{display:'flex',flexDirection:'column'}}>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Tracknametag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Labeltag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Genretag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Releasedatetag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Songwriterstag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Producerstag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Featuredartiststag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Explicitcontenttag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Instrumentaltag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Radioedittag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Pricetag')}</div>
//                                 <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Royaltysplittag')}</div>
//                             </div>

//                             <div style={{display:'flex',flexDirection:'column'}}>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.trackname}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.label}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.genre}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.releasedate}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.songwriters}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.producers}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.featuredartists}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.explicitcontent}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.instrumental}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.radioedit}</div>
//                                 <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.price}</div>
//                                 <div className="MetadataInfo">Peggy Gou: 60% <br/>Artist Name : 40% </div>
//                             </div>
//                         </div>
                     
//                     </div>
//                 </div>

               

//             <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
//                 <div style={{display:'flex',flexDirection:'row',justifyContent:'center',marginTop:'3em',width:'100%',alignSelf:'center'}}>
//                     {
//                         albumAnalyticsOption===1 &&
//                         <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
//                              {t('1wk')} 
//                         </div>
//                     }

//                     {
//                         albumAnalyticsOption!==1 &&
//                         <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
//                             {t('1wk')} 
//                         </div>
//                     }

//                     {
//                         albumAnalyticsOption===2 &&
//                         <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
//                            {t('1mo')} 
//                         </div>
//                     }

//                     {
//                         albumAnalyticsOption!==2 &&
//                         <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
//                             {t('1mo')} 
//                         </div>
//                     }

//                     {
//                         albumAnalyticsOption===3 &&
//                         <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
//                              {t('All')} 
//                         </div>
//                     }

//                     {
//                         albumAnalyticsOption!==3 &&
//                         <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
//                              {t('All')} 
//                         </div>
//                     }                       

//                 </div>

//                 <div className="StreamsTxt">
//                     {t('Streams')} 
//                 </div>
                
//                 {
//                    albumAnalyticsOption===1 && 
//                    <div className="StreamsNo">
//                    85.5k
//                     </div>
//                 }

//                 {
//                    albumAnalyticsOption===2 && 
//                    <div className="StreamsNo">
//                    402k
//                     </div>
//                 }

//                 {
//                    albumAnalyticsOption===3 && 
//                    <div className="StreamsNo">
//                    1.93M
//                     </div>
//                 }   
             
//             </div>
//         </div>
//             }

           
//         </div>
//             }
//         </div>
        
//     );
// }

// export default Music;